import { render } from "./VariantsList.vue?vue&type=template&id=5d605830&scoped=true"
import script from "./VariantsList.vue?vue&type=script&lang=js"
export * from "./VariantsList.vue?vue&type=script&lang=js"

import "./VariantsList.vue?vue&type=style&index=0&id=5d605830&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d605830"]])

export default __exports__